import { useTolgee } from "@tolgee/react";
import { useExplainerImage, useResponsiveImageSize } from "../../hooks";
import { ExplainerExpression } from "../../types/explainer";
import { FC } from "react";

export const ExplainerImage: FC<{ data: ExplainerExpression }> = ({ data }) => {
  const tolgee = useTolgee();
  const explainerImage = useExplainerImage(data, tolgee.getLanguage());
  const imageSize = useResponsiveImageSize(explainerImage);

  if (!explainerImage) return null;

  return (
    <img
      id="explainer-image"
      src={explainerImage.src}
      alt="explainer"
      className="pt-[45px]"
      width={imageSize?.width}
      height={imageSize?.height}
    />
  );
};
